/**
 * UserProfileLink — a participant's name, linked to their admin profile (/users/:id).
 *
 * The profile is where an admin reads what happened to a member: their matches with
 * each side's decision, activity, photos and safety timeline. Used by the match list
 * rows and the match detail header.
 *
 * The click stops propagating: a list row opens the match detail on click, and the
 * link must not do that as well. A plain <a href> (react-router Link) keeps
 * Cmd/Ctrl-click and middle-click opening the profile in a new tab; the list keeps
 * its filters and open match in the URL, so Back restores it.
 */
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function UserProfileLink({ userId, children }: { userId: string; children: ReactNode }) {
  return (
    <Link
      to={`/users/${userId}`}
      onClick={e => e.stopPropagation()}
      className="text-primary no-underline hover:underline"
      title="Open user profile"
    >
      {children}
    </Link>
  );
}
